'use client';
import React from 'react';
import { PhoneIcon, EnvelopeIcon, MapPinIcon, ClockIcon } from '@heroicons/react/24/outline';

interface ContactDetail {
    title: string;
    details: string[];
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const contactInfo: ContactDetail[] = [
    {
        title: 'Phone',
        details: ['(562) 618-4677'],
        icon: PhoneIcon
    },
    {
        title: 'Email',
        details: ['cs@junctionil.com', 'procurement@junctionil.com'],
        icon: EnvelopeIcon
    },
    {
        title: 'Office',
        details: ['100 W Victoria St Long Beach', 'CA 90805 USA'],
        icon: MapPinIcon
    }
];

const ContactInfo: React.FC = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <div className="inline-block px-4 py-2 bg-[#29abe2] bg-opacity-10 rounded-full mb-4">
                        <span className="text-[#29abe2] font-semibold">Contact Information</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Get in Touch with Us
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        We&apos;re here to help! Contact us through any of these channels
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8">
                    {contactInfo.map((info, index) => (
                        <div 
                            key={index}
                            className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 text-center"
                        >
                            <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#29abe2] bg-opacity-10 mb-6">
                                <info.icon className="h-8 w-8 text-[#29abe2]" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                {info.title}
                            </h3>
                            {info.details.map((detail, idx) => (
                                <p key={idx} className="text-gray-600">
                                    {detail}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ContactInfo; 